import { FieldError } from 'react-hook-form';
import { styled } from '../../../base-components';

export const StyledQuillWrapper = styled('div')<{ error?: FieldError }>(
    ({ theme, error }) => ({
        '& .ql-container': {
            borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.fontSize,
            border: `1px solid ${error ? theme.palette.error.main : theme.palette.divider}`,
        },
        '& .ql-toolbar': {
            borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
            border: `1px solid ${error ? theme.palette.error.main : theme.palette.divider}`,
            borderBottom: 'none',
        },
        '& .ql-editor': {
            minHeight: '250px',
            padding: theme.spacing(2),
            textAlign: 'start',
        },
        '& .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg':
            {
                right: 'inherit',
                insetInlineEnd: 0,
            },
    })
);

export const ErrorText = styled('div')(({ theme }) => ({
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(12),
    marginTop: theme.spacing(0.5),
}));

export const CharacterCount = styled('div')(({ theme }) => ({
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    textAlign: 'right',
    marginTop: theme.spacing(0.5),
}));
